import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LT_BRAND, LT_ROUTES } from "../data";
import BrandMark from "./BrandMark";

/**
 * The title block: one strip along the bottom edge of the sheet, the fields a
 * drafter fills in on every drawing. `Sheet` names the route you are on.
 */
export default function Footer({ lang = "en", theme }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const tagline = LT_BRAND.tagline[lang] || LT_BRAND.tagline.en;
  const year = new Date().getFullYear();
  // The router matches ignoring trailing slashes and case; so does the sheet.
  const canonical = pathname.replace(/\/+$/, "").toLowerCase() || "/";
  const route = LT_ROUTES.find((r) => r.to === canonical);
  const sheet = route ? t(route.key) : t("notFound.title");
  const host = (url) => url.replace(/^https?:\/\/(www\.)?/, "");

  return (
    <footer className="title-block">
      <div className="tb-wrap">
        <div className="tb-inner">
          <div className="tb-cell tb-logo">
            <BrandMark theme={theme} className="tb-mark" />
          </div>

          <div className="tb-cell">
            <div className="tb-k">{t("titleBlock.project")}</div>
            <div className="tb-v">{LT_BRAND.name}</div>
            <div className="tb-s">{tagline}</div>
          </div>

          <div className="tb-cell">
            <div className="tb-k">{t("titleBlock.address")}</div>
            <div className="tb-v">{LT_BRAND.street}</div>
            <div className="tb-s">{LT_BRAND.city}, CH</div>
          </div>

          <div className="tb-cell">
            <div className="tb-k">{t("titleBlock.sheet")}</div>
            <div className="tb-v">{sheet}</div>
            <div className="tb-s">{pathname}</div>
          </div>

          <div className="tb-cell">
            <div className="tb-k">{t("titleBlock.rev")}</div>
            <div className="tb-v">{year}</div>
            <div className="tb-s">
              {t("titleBlock.drawnBy")} {LT_BRAND.short}
            </div>
          </div>

          <div className="tb-cell">
            <div className="tb-k">{t("titleBlock.links")}</div>
            <a
              className="tb-v tb-link"
              href={LT_BRAND.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              {host(LT_BRAND.github)}
            </a>
            <a
              className="tb-s tb-link"
              href={LT_BRAND.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              {host(LT_BRAND.linkedin)}
            </a>
          </div>

          <div className="tb-cell">
            <div className="tb-k">{t("titleBlock.uid")}</div>
            <div className="tb-v">{LT_BRAND.uid}</div>
            <Link className="tb-s tb-link" to="/legal">
              {t("footer.legalLink")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
